import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    OBTENER_USUARIO,
    CARGANDO_LOGIN,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    OCULTAR_MENSAJE_ALERTA
} from '../../types';

export default (state, action) => {
    switch(action.type) {
        case CARGANDO_LOGIN:
            return {
                ...state,
                cargandologin: true
            }
        case LOGIN_EXITOSO:
            localStorage.setItem('token', action.payload.token);
            return {
                ...state,
                token: action.payload.token,
                autenticado: true,
                mensaje: null,
                cargando: false,
                cargandologin: false
            }
        case REGISTRO_EXITOSO:
            return {
                ...state,
                mensaje: action.payload,
            }
        case OBTENER_USUARIO:
            return {
                ...state,
                autenticado: true,
                usuario: action.payload,
                cargando: false
            }
        case CERRAR_SESION:
        case LOGIN_ERROR:
            localStorage.removeItem('token');
            return {
                ...state,
                token: null,
                usuario: null,
                autenticado: null,
                mensaje: action.payload,
                cargando: false,
                cargandologin: false
            }
        case REGISTRO_ERROR:
            return {
                ...state,
                mensaje: action.payload,
                cargando: false
            }
        case OCULTAR_MENSAJE_ALERTA:
            return {
                ...state,
                mensaje: null
            }
        default:
            return state;
    }
}